import { AudioManager } from "../../AudioManager";
import { HelpParameters, Help, HelpPanelColor} from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_Responsive } from "../SlotGameType1_Responsive";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";

// namespace SlotGames {

    export class GoldAndRum_Responsive extends SlotGameType1_Responsive {

        
        protected override helpFactory: IHelpFactory = new GoldAndRumHelpFactory();
        //LED COLOR
		protected override ColorLed:string="0,166,214\n";
        constructor(multigameParams: MultigameParams, initData: SlotGameInitData , gameName:string = "GoldAndRum") {
            super(multigameParams, initData, gameName);

            this.spinnableReelsParams.topBorderWidth = 8;
            this.spinnableReelsParams.bottomBorderWidth = 8;
        }

        // protected PrepareFonts(resourceManager: ResourceManager): void {

        //     resourceManager.Add(new FontResource(this.basepath + "resources/Monky Stone.ttf", this.resid.ScopedResourceName(["BigSymbolFreeGames-font"])));

        // }

        //SEND COLOR 
        protected override color: RewardColor = 
        {
            color: "white",
            coloroutherStroke: "black",
            colorinnerStroke: "cyan",
        }


    }

    //Help Colorized
    class GoldAndRumHelpFactory implements IHelpFactory {
        public CreateNewHelp(params: HelpParameters): Help {
            return new GoldAndRumHelp(params);
        }
    }

    class GoldAndRumHelp extends Help {
        protected override BackgroundPanel(): HelpPanelColor {
            let color: HelpPanelColor = {
                backgroundPanelColor: "linear-gradient(rgb(38, 21, 15),rgb(89, 55, 35), rgb(140, 101, 66),rgb(89, 55, 35),rgb(38, 21, 15)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
            };

            return color;
        }
    }
// }